import styled from "styled-components";

const RecommendedInPlayerContainer = styled.div`
  .rc {
    position: absolute;
    background: rgba(0, 0, 0, 0.9);
    z-index: 99;
    display: flex;
    flex-wrap: wrap;
    place-content: center;
    align-items: center;
    padding-top: 45px;
    .result-item {
      max-width: 260px;
      min-width: 260px;
      min-height: 190px;
      margin: 0 5px;
      img {
        max-width: 260px;
        max-height: 148px;
        height: 100%;
        margin: auto;
        display: block;
      }
      .imgthumb {
        overflow: hidden;
        .image-container {
          height: 148px;
        }
      }
      .itemBottom {
        display: none;
      }
      .itemTitle {
        background: none;
        h3 {
          font-size: 12px;
          color: #fff;
        }
        .date__clearance {
          display: none;
        }
      }
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1364px) {
    .rc {
      .result-item {
        max-width: 230px;
        min-width: 230px;
        img {
          max-width: 230px;
        }
      }
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1214px) {
    .rc {
      .result-item {
        max-width: 180px;
        min-width: 180px;
        img {
          max-width: 180px;
        }
      }
    }
  }

  @media screen and (max-width: 809px) {
    .rc {
      display: none;
    }
  }
`;

export default RecommendedInPlayerContainer;
